module.exports = __webpack_public_path__ + "img/theatre_4.6286c373.jpg";